export type ProgressStatus = "On Track" | "Needs Support" | "Behind" | "Inactive" | "Pending";

export type Project = {
  name: string;
  group: string;
  schools: number;
  teachers: number;
  percent: number;
  status: ProgressStatus;
};

export const projects: Project[] = [
  { name: "SEEK Mumbai · Marathi", group: "SEEK Mumbai", schools: 14, teachers: 223, percent: 48, status: "Needs Support" },
  { name: "SEEK Mumbai · Hindi", group: "SEEK Mumbai", schools: 12, teachers: 196, percent: 57, status: "Needs Support" },
  { name: "SEEK Pune · English", group: "SEEK Pune supported by Omni Active ILF", schools: 10, teachers: 144, percent: 62, status: "On Track" },
  { name: "SEEK Mumbai · English BMC SSC", group: "SEEK Mumbai BMC SSC", schools: 8, teachers: 126, percent: 70, status: "On Track" },
];

export const attentionTeachers = [
  { name: "Amita Vidyalaya", school: "SEEK Mumbai Hindi", teacher: "Meenal Shah", detail: "7 weeks inactive", status: "Inactive" as ProgressStatus },
  { name: "Shankarrao U P Marathi", school: "SEEK Mumbai Marathi", teacher: "Ashwini More", detail: "5 lessons behind", status: "Behind" as ProgressStatus },
  { name: "Pupils Academy High School", school: "SEEK Pune English", teacher: "Sanjay Bhosale", detail: "3 submissions pending", status: "Pending" as ProgressStatus },
  { name: "Nagar Parishad School", school: "SEEK Mumbai Hindi", teacher: "Kavita Patil", detail: "3 weeks inactive", status: "Inactive" as ProgressStatus },
];

export const months = ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov"];
export const monthlyTarget = [30, 44, 50, 48, 53, 58, 60, 62];
export const monthlyActual = [28, 36, 48, 42, 55, 47, 58, 51];

export const teacherModules = [
  { name: "Mindfulness", completed: 3, inProgress: 1, total: 15, color: "#803293" },
  { name: "Health Is Wealth", completed: 4, inProgress: 1, total: 16, color: "#009594" },
  { name: "You're The Voice", completed: 0, inProgress: 1, total: 15, color: "#55ba5a" },
];

export const adminInsights = [
  { label: "Module completion", value: "61%", detail: "4% above last month", color: "#55ba5a" },
  { label: "Search adoption", value: "43%", detail: "1,204 opened activities", color: "#009594" },
  { label: "Needs a look", value: "9", detail: "Projects not reviewed in 3+ weeks", color: "#a93132" },
];
